import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { intlShape, historyShape } from './prop-types';
import { clearLoggedAccount } from '../reducers/account';
import { clearCredentialsSession } from '../services/auth/auth-storage';
import apollo from '../services/apollo';

export const VIEWER_ID = gql`
  query getViewerId {
    viewer {
      id
    }
  }
`;

const i18nMessages = defineMessages({
  profile: {
    id: 'menu.profile',
    defaultMessage: 'User Profile',
  },
  logout: {
    id: 'menu.logout',
    defaultMessage: 'Logout',
  },
  login: {
    // TODO: we should update ID then updated translations files to match
    id: 'attrs.login',
    defaultMessage: 'Sign in',
  },
  authenticationDetails: {
    id: 'attrs.authentication-details',
    defaultMessage: 'Authentication Details',
  },
  userDetails: {
    id: 'attrs.user-details',
    defaultMessage: 'User Details',
  },
  actions: {
    id: 'attrs.actions',
    defaultMessage: 'Actions',
  },
});

class AppTopbarMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountId: null,
      userId: null,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    apollo.query({
      query: VIEWER_ID,
    }).then((res) => {
      const { data } = res;
      const { viewer } = data;
      const { id } = viewer;

      this.setState({
        userId: id,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      accountId: nextProps.accountId,
    });
  }

  toggleMenu(event) {
    this.menu.toggle(event);
  }

  render() {
    const {
      intl,
      clearAccount,
      history,
    } = this.props;

    const { formatMessage } = intl;

    const { accountId, userId } = this.state;
    const userDetailPageLinkDisabled = accountId == null || userId == null;

    const items = [
      {
        label: formatMessage(i18nMessages.userDetails),
        disabled: userDetailPageLinkDisabled,
        icon: 'pi pi-user',
        command: () => {
          const url = `/accounts/${accountId}/users/${userId}`;
          history.push(url);
        },
      },
      {
        label: intl.formatMessage(i18nMessages.logout),
        icon: 'pi pi-sign-out',
        command: () => {
          clearAccount();
          clearCredentialsSession();
          history.push('/');
        },
      },
    ];

    const { name } = 'test';
    return (
      <div>
        <Menu
          model={items}
          popup
          ref={(el) => {
            this.menu = el;
            return el;
          }}
          appendTo={document.body}
        />
        <Button label={name} className="p-button-secondary" icon="pi pi-user" onClick={this.toggleMenu} />
      </div>
    );
  }
}

AppTopbarMenu.propTypes = {
  intl: intlShape.isRequired,
  history: historyShape.isRequired,
  clearAccount: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

const mapProps = dispatch => ({
  clearAccount: () => dispatch(clearLoggedAccount()),
});

export default connect(null, mapProps)(
  withRouter(injectIntl(AppTopbarMenu)),
);
